// extracted by mini-css-extract-plugin
export default {"page":"SellerUniversity_page__0EMgQ","universityCard":"SellerUniversity_universityCard__jt-XF"};